module.exports = __webpack_public_path__ + "img/ic-screens-hover.4d02b586.svg";